import { Link } from 'react-router-dom';

type Props = {
  imgSrc: string | React.ReactNode;
  width: number | string;
  height: number | string;
  path: string;
};

const ClickableImage = (props: Props) => {
  const { imgSrc, width, height, path } = props;
  return (
    <Link to={path} style={{ width, height }}>
      {typeof imgSrc === 'string' ? <img src={imgSrc} alt="logo" style={{ width, height }} /> : imgSrc}
    </Link>
  );
};

export default ClickableImage;
